import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo.jsx';

/**
 * Шапка по макету: логотип слева, набор ссылок-действий справа.
 * props.actions: [{ label, onClick }]
 * props.logoTo: маршрут по клику на логотип (по умолчанию '/').
 */
export default function LmHeader({ actions = [], logoTo = '/', logoColor, className = '' }) {
  const navigate = useNavigate();

  return (
    <header className={`lm-header${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        className="lm-logo-link"
        onClick={() => navigate(logoTo)}
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        aria-label="Лимитек"
      >
        <Logo size="lg" color={logoColor} />
      </button>

      {actions.length > 0 && (
        <nav className="lm-header__actions">
          {actions.map((a, i) => (
            <button key={i} type="button" className="lm-headerlink" onClick={a.onClick}>
              {a.label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
}
